var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef, useRef, } from "react";
import { ArrowRightIcon } from "@navikt/aksel-icons";
import { Slot } from "../../slot/Slot.js";
import { useRenameCSS } from "../../theme/Theme.js";
import { composeEventHandlers } from "../composeEventHandlers.js";
import { createContext } from "../create-context.js";
import { useMergeRefs } from "../hooks/useMergeRefs.js";
import { ownerWindow } from "../owner.js";
const [LinkAnchorContextProvider, useLinkAnchorContext] = createContext({
    name: "LinkAnchorOverlayContext",
});
const LinkAnchorOverlay = forwardRef((_a, forwardedRef) => {
    var { children, asChild, className, onClick } = _a, restProps = __rest(_a, ["children", "asChild", "className", "onClick"]);
    const { cn } = useRenameCSS();
    const anchorRef = useRef(null);
    const Component = asChild ? Slot : "div";
    return (React.createElement(LinkAnchorContextProvider, { anchorRef: anchorRef },
        React.createElement(Component, Object.assign({ ref: forwardedRef }, restProps, { className: cn("navds-link-anchor__overlay", className), onClick: composeEventHandlers(onClick, (e) => {
                var _a;
                if (e.target === anchorRef.current ||
                    isTextSelected(anchorRef.current)) {
                    return;
                }
                const event = new MouseEvent("click", {
                    bubbles: true,
                    cancelable: true,
                    view: window,
                    ctrlKey: e.ctrlKey,
                    shiftKey: e.shiftKey,
                    altKey: e.altKey,
                    metaKey: e.metaKey,
                    button: e.button,
                    screenX: e.screenX,
                    screenY: e.screenY,
                    clientX: e.clientX,
                    clientY: e.clientY,
                });
                (_a = anchorRef.current) === null || _a === void 0 ? void 0 : _a.dispatchEvent(event);
            }) }), children)));
});
const LinkAnchor = forwardRef((_a, forwardedRef) => {
    var { children, asChild, className } = _a, restProps = __rest(_a, ["children", "asChild", "className"]);
    const { cn } = useRenameCSS();
    const context = useLinkAnchorContext(false);
    const mergedRefs = useMergeRefs(forwardedRef, context === null || context === void 0 ? void 0 : context.anchorRef);
    const Component = asChild ? Slot : "a";
    return (React.createElement(Component, Object.assign({ ref: mergedRefs }, restProps, { className: cn("navds-link-anchor", className) }), children));
});
const LinkAnchorArrow = forwardRef((_a, forwardedRef) => {
    var { className } = _a, restProps = __rest(_a, ["className"]);
    const { cn } = useRenameCSS();
    return (React.createElement(ArrowRightIcon, Object.assign({ ref: forwardedRef, "aria-hidden": true, className: cn("navds-link-anchor__arrow", className) }, restProps)));
});
/* -------------------------- LinkAnchor Utilities -------------------------- */
function isTextSelected(refElement) {
    var _a, _b;
    return !!((_b = (_a = ownerWindow(refElement)) === null || _a === void 0 ? void 0 : _a.getSelection()) === null || _b === void 0 ? void 0 : _b.toString());
}
export { LinkAnchor, LinkAnchorArrow, LinkAnchorOverlay };
//# sourceMappingURL=LinkAnchor.js.map